import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map, retry } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ApiEnum, HttpDataService } from "./http-data.service";
import { CebesCentrosViewModel } from "../models/centros/centro-list-base.model";

@Injectable({
	providedIn: "root",
})
export class CebesCentrosService {
	constructor(private readonly httpDataService: HttpDataService) {}

	getContratoCentroByCentro(id: number): Observable<CebesCentrosViewModel> {
		return this.httpDataService
			.get$<CebesCentrosViewModel>(
				ApiEnum.API_ROOT,
				`${environment.endpoint.centros.getContratoCentroByCentro}/${id}`
			)
			.pipe(
				map((cebeCentro) => {
					return cebeCentro;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CebesCentrosViewModel>(
						"getContratoCentroByCentro"
					)
				)
			);
	}
}
